/**
 * Ensures only the first accordion row is open on initial page load.
 */
class ProductMetafieldAccordion extends HTMLElement {
  #initialized = false;

  connectedCallback() {
    this.#setInitialOpenState();
  }

  #setInitialOpenState() {
    if (this.#initialized) return;
    this.#initialized = true;

    const accordionItems = [...this.querySelectorAll(':scope > accordion-custom')];

    accordionItems.forEach((item, index) => {
      const details = item.querySelector('details');

      if (!(details instanceof HTMLDetailsElement)) return;

      details.open = index === 0;
    });
  }
}

if (!customElements.get('product-metafield-accordion')) {
  customElements.define('product-metafield-accordion', ProductMetafieldAccordion);
}
